import * as React from "react";

export const IconTrack = () => <span className="icon-track" />;
export const IconItalic = () => <span className="icon-italic" />;
export const IconUnorderedList = () => <span className="icon-unordered-list" />;
export const IconOrderedList = () => <span className="icon-ordered-list" />;
export const IconPrint = () => <span className="icon-print" />;
export const IconFeedback = () => <span className="icon-feedback" />;
export const IconPeople = () => <span className="icon-people" />;
export const IconCycle = () => <span className="icon-cycle" />;
export const IconInstructions = () => <span className="icon-instructions" />;
export const IconRemove = () => <span className="icon-remove" />;
export const IconCalendar = () => <span className="icon-calendar" />;
export const IconCheck = () => <span className="icon-check" />;
export const IconCheckRounded = () => <span className="icon-check-rounded" />;
export const IconArrowDropDown = () => <span className="icon-arrow-drop-down" />;
export const IconHidden = () => <span className="icon-hidden" />;
export const IconVisible = () => <span className="icon-visible" />;
export const IconLogout = () => <span className="icon-logout" />;
export const IconMenu = () => <span className="icon-menu" />;

export const IconFreeText = () => <span className="icon-free-text" />;
export const IconRadio = () => <span className="icon-radio" />;
export const IconRadioFreeText = () => <span className="icon-radio-free-text" />;
export const IconScale = () => <span className="icon-scale" />;
export const IconCompanyValue = () => <span className="icon-company-value" />;
export const IconCustomCompanyValue = () => <span className="icon-custom-company-value" />;
